module.exports = __webpack_public_path__ + "media/images/topics/cover-362cb541c77cbef1ab1a3f689a7d5b77.svg";